import styled, { css } from 'styled-components'

export const InputActionButtonsWrapper = styled.div<{
  $isStaticView: boolean
}>`
  ${({ $isStaticView }) =>
    $isStaticView
      ? css`
          position: absolute;
          right: 1px;
          top: 1px;
          width: 70px;
          height: calc(100% - 2px); //border

          display: flex;
          justify-content: flex-end;
          align-items: center;

          border-radius: 0 4px 4px 0;

          overflow: hidden;
        `
      : ''}
`
